import React from "react";
import AddEntityPopup from "components/Records/NewRecordPages/AddEntityPopup";
import { peopleAPI } from "api/Community/PeopleAPI";

interface AddPeoplePopupProps {
  open: boolean;
  onClose: () => void;
  onSaved?: (newPerson: any) => void;
}

const AddPeoplePopup: React.FC<AddPeoplePopupProps> = ({ open, onClose, onSaved }) => {
  return (
    <AddEntityPopup
      open={open}
      onClose={onClose}
      title="Add New Person"
      createFunction={peopleAPI.create as (data: Record<string, any>) => Promise<any>}
      fields={[
        { name: "first_name", label: "First Name", required: true },
        { name: "last_name", label: "Last Name", required: false },
      ]}
      onSaved={onSaved}
    />
  );
};

export default AddPeoplePopup;
